import download from 'downloadjs';

export default function fileDownload(content, fileName, mimeType) {

  return download(
    'data:' + mimeType + ';charset=UTF-8,' + encodeURIComponent(content),
    fileName,
    mimeType
  );
}